import {
  CustomStopLossFilter,
  PaginatedResult,
  CustomStopLoss,
} from 'common/models';
import http from 'core/services/api';

class CustomStopLossRepository {
  getCustomStopLosses = async ({
    page = 1,
    perPage = 10,
    orderDir = 'asc',
    orderBy = 'stopPrice',
    ...params
  }: CustomStopLossFilter) =>
    http.fetch(async (axios, signal) => {
      return axios.get<PaginatedResult<CustomStopLoss>>(
        `/custom-stop-losses/filter`,
        {
          signal,
          params: {
            ...params,
            orderDir,
            orderBy,
            perPage,
            page,
          },
        }
      );
    });

  cancelCustomStopLoss = async ({ id }: { id: string }) =>
    http.fetch(async (axios, signal) => {
      return axios.post<void>(
        `/custom-stop-losses/${id}/cancel`,
        {},
        {
          signal,
        }
      );
    });
}

export const customStopLossRepository = new CustomStopLossRepository();
